import { AbstractProjectModel } from "@app/catalog-common";

export class ProjectAddedMessage {
    public project: AbstractProjectModel;
    
    constructor(project: AbstractProjectModel)
    {
        this.project = project;
    }
}